import React from 'react';
import styles from './DropdownItem.module.scss';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import useAccessibleClick from '../../../../../common/hooks/useAccessibleClick';

const DropdownItem = ({ inputRef = null, filter, handleClick, selectedFilter }) => {
  const { t } = useTranslation();

  const myRef = useAccessibleClick(() => handleClick(filter), inputRef);

  return (
    <div
      ref={myRef}
      className={cx(styles.dropdownItem, { [styles.active]: filter.ROLE == selectedFilter.ROLE })}
      onClick={() => handleClick(filter)}
      tabIndex={0}
    >
      <p>{t(filter.TEXT)}</p>
    </div>
  );
};

export default DropdownItem;
